var config = require('../config.js')
module.exports = {
    naviConfigListHeader: config.host + '/offical/api/v1/navi-config/list-header/c', // 导航列表
    newsManageByDetail: config.host + '/offical/api/v1/news/manage/byDetail/c', // 获取新闻详情
    newsManageByCount: config.host + '/offical/api/v1/news/manage/byCount/c', // 统计访问数量
    newsManageList: config.host + '/offical/api/v1/news/manage/list/c', // 获取新闻管理列表
    pageByDetail: config.host + '/offical/api/v1/page/byDetail/c', // 获取内容详情
    
}